import { Controller } from '@hotwired/stimulus';

// 年タブの active 表示切り替えと読み込み中スピナー。
// コンテンツ差し替えは Turbo Frame (#payments) が担う。
export default class extends Controller {
  // URL に #2025 のようなハッシュがあれば、その年のタブを開く。
  // 旧 dashboard の inline jQuery ($('li#payYear'+hash+' a').click()) を移植。
  // connect 時点ではブラウザがまだフラグメントを location へ適用していないことが
  // あるため、即時に試すのに加えて hashchange / load でも試す。
  connect() {
    this.onHashChange = () => this.openHashTab();
    window.addEventListener('hashchange', this.onHashChange);
    window.addEventListener('load', this.onHashChange);
    this.openHashTab();
  }

  disconnect() {
    window.removeEventListener('hashchange', this.onHashChange);
    window.removeEventListener('load', this.onHashChange);
  }

  openHashTab() {
    const hash = window.location.hash.replace(/^#/, '');
    if (!/^\d+$/.test(hash)) { return; }
    const li = this.element.querySelector(`#payYear${hash}`);
    const link = li && li.querySelector('a');
    if (link && !link.classList.contains('active')) { link.click(); }
  }

  select(event) {
    this.element.querySelectorAll('a.active').forEach((el) => el.classList.remove('active'));
    event.currentTarget.classList.add('active');
    this.showLoading();
  }

  showLoading() {
    const loading = document.getElementById('payments_loading');
    const payments = document.getElementById('payments');
    if (!loading) { return; }
    if (payments) { payments.style.visibility = 'hidden'; }
    loading.style.display = 'block';

    const frame = document.getElementById('payments');
    if (!frame) { return; }
    const done = () => {
      loading.style.display = 'none';
      frame.style.visibility = 'visible';
      frame.removeEventListener('turbo:frame-render', done);
    };
    frame.addEventListener('turbo:frame-render', done, { once: true });
  }
}
